module.exports = __webpack_public_path__ + "static/media/west-campus.a166e788.jpg";